export default {
  noActiveRecipe: 'Na tejto peci nie je aktívny žiaden recept.',
  confirmSave: {
    header: 'Uložiť požadované hodnoty?',
    message: 'Požadované hodnoty sa nahrajú do pece a jej aktuálne požadované hodnoty sa nastavia na tieto hodnoty.',
  },
};
